import React from 'react';

const EmptyIcon = ({active}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38"/>
);

export default EmptyIcon;
